import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
import { useLocation } from "react-router-dom";

const useEmpMapSubmission = (formData, refetch, workflowDetails, userRolesArray, urlFormType) => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source") || "";
  console.log("fromDashboardcheckSourceAyush", source, location);
  const isFromDashboard = location?.pathname?.includes("dashboard-details") || source === "dashboard";
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  console.log(useParams(), "paramsHookFromMapSUb", userDetails);
  const { t } = useTranslation();
  const [iframeSrc, setIframeSrc] = useState("");
  const [pdfIframeSrc, setPdfIframeSrc] = useState("");
  const [inspectionDataResp, setInspectionDataResp] = useState(null);
  const [additionalComment, setAdditionalComment] = useState("");
  const {
    paymentHeadRemarksData,
    documentRemarksData,
    siteInspectionRemarksData,
    siteDrawingRemarksData,
    pFarDetailsData,
    chatBoardDataRemarks,
    chatBoardHistoryData,
    notingRemarksData,
    nocRemarksData,
    handleGetFiledsStatesById,
    handleGetRemarkssValues,
    handleGetPaymentHeadById,
    handleGetDrawingById,
    handlepFarDetailById,
    handleGetDocumentById,
    handleGetNotingById,
    handleGetNocById,
    handleGetSiteInspectionById,
  } = useContext(ScrutinyRemarksContext);
  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState("");
  const [currentView, setCurrentView] = useState("documents");
  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const [typeOfLetter, setTypeOfLetter] = useState("");
  const [customLetter, setCustomLetter] = useState([]);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.documents);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState(formData?.inspectionDetailData);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [taxHead, setTaxHead] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [officerNocDetails, setOfficerNocDetails] = useState(formData?.nocDetails);
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto", "kmlFile"];
  // Normal remarks
  const isPurchasbleReq = formData?.plotLeaseHold === "yes";
  // Drawing Details
  const [drawingRemarks, setDrawingRemarks] = useState(null);
  const [drawingRecommendation, setDrawingRecommendation] = useState("");

  // Payment Details
  const [paymentRemarks, setPaymentRemarks] = useState(null);
  const [paymentRecommendation, setPaymentRecommendation] = useState("");
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  // Document Remarks
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  // Noc remarks
  const [developerNocRemarks, setDeveloperNocRemarks] = useState(null);
  const [dataNocRecommendation, setDataNocRecommendation] = useState("");
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  // const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [selectedObjection, setSelectedObjection] = useState("");
  const [mapSubNocDetails, setMapSubNocDetails] = useState(formData?.nocDetails);
  const [callAPI, setCallAPI] = useState(false);
  // const nocInitialValue =
  //   (formData?.riskType != "LOW" && Object.values(formData?.nocDetails?.officerNOCData)?.some(Boolean)) ||
  //   formData?.nocDetails?.additionalOfficerNOCData?.length > 0;
  const [isNoNoc, setIsNoNoc] = useState(true);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEE = userRolesArray?.[0]?.code === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const [mapSubmissionAction, setMapSubmissionAction] = useState(null);
  const isDa = formData?.department === "DA";
  const isCitizen = user?.info?.type === "CITIZEN";
  const inspectionReportChecklist = useSelector((state) => state.inspectionReportChecklist);
  const reduxFormData = useSelector((state) => state?.inspectionReportData);
  const userRoles = user?.info?.roles?.map((e) => e.code);
  console.log("reduxFormData", reduxFormData, "formData", formData, "inspectionReportChecklist", inspectionReportChecklist, "user", user);
  const isNocModule = urlFormType === "NOC";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, isNocModule ? "NOC" : false);
  const userRolesWithoutEMP = user?.info?.roles.filter((user) => user.code != "EMPLOYEE");
  const drawingPdfs = formData?.documents?.filter((doc) => ["drawingPdf"].includes(doc.documentType));
  const Modal = useModal();
  const appType = formData?.applicationType;
  const isMapSubmission = appType === "FORM_MAP";
  const isCompletionPortal = appType === "FORM_COMPLETION";
  const isPlinthSubmission = appType === "FORM_PLINTH";
  const isPurchasbleFAR = appType === "FORM_PURCHASABLE_FAR";
  const isCompounding = appType === "FORM_COMPOUNDING";
  const [initialUrl, setInitialUrl] = useState("");
  const documentSection = formData?.documents?.filter((doc) => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType));
  const fetchInitialUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    // console.log("responseFromFileStore", response.data.fileStoreIds[0].url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    setIframeSrc(response.data.fileStoreIds[0].url);
    // return response.data.fileStoreIds[0].url || "";
  };
  const fetchInitialPdfUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    console.log("responseFromFileStore", response?.data?.fileStoreIds?.[0]?.url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    setPdfIframeSrc(response?.data?.fileStoreIds?.[0]?.url);
    // return response.data.fileStoreIds[0].url || "";
  };
  const getValidityOfEmp = () => {
    if (formData?.assignes?.length > 0) {
      console.log("loggingValidityOfEmp", formData?.assignes?.[0]?.uuid === userInfo?.uuid);

      return formData?.assignes?.[0]?.uuid === userInfo?.uuid;
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  const currentFormData = formData?.nocList?.find((item) => item?.businessService === userDetails?.organisationCode);

  useEffect(() => {
    // const isDocValidated = formData?.documents?.some((item) => item.documentRemarks !== null);
    const isDocValidated = formData?.documents
      ?.filter((item) => !excludedTypesForDocSection.includes(item.documentType))
      .every((item) => !item.isMandatory || item.documentRemarks !== null);
    const isNocValidated =
      (formData?.nocDetails?.officerNOCData && Object.values(formData?.nocDetails?.officerNOCData)?.some(Boolean)) ||
      formData?.nocDetails?.additionalOfficerNOCData?.length > 0;
    console.log("isValidationsss", { isDocValidated, isNocValidated });

    if (isDocValidated) {
      Digit?.SessionStorage.set("isDocValidated", isDocValidated);
    }
    if (isNocValidated) {
      Digit?.SessionStorage.set("isNocValidates", isNocValidated);
    }
    // const isPaymenthead = formData?.taxHeadEstimates?.some((item) => item.calculationBusinesserviceId == "BPA.MAP_SUBMISSION_FORM_FEE2");
    // if (isPaymenthead) {
    //   Digit?.SessionStorage.set("isPaymenthead", isPaymenthead);
    // }
    fetchInitialUrl(documentSection?.[0]?.fileStoreId);
    if (drawingPdfs) {
      fetchInitialPdfUrl(drawingPdfs?.[0]?.fileStoreId);
    }
  }, []);
  const handleDocView = () => {
    setCurrentView((prev) => (prev === "documents" ? "viewDocuments" : "documents"));
  };
  const isSelfApproval =
    (formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ||
      formData?.planOn === "SELF_MAP") &&
    ["APPROVED", "APPROVED_JE"].includes(formData?.status);
  const handleLetterView = () => {
    setCurrentView((prev) => (prev === "letter" ? "viewDocuments" : "letter"));
  };
  const handleNoWorkflow = (updatedDocuments) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      documents: updatedDocuments,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          // setDeveloperUpdateDocument("DocumentDetailsUpdated");
          onSelect("", result?.BPA?.[0]);
          // const isDocValidated = result?.BPA?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          const isDocValidated = result?.BPA?.[0]?.documents
            ?.filter((item) => !excludedTypesForDocSection.includes(item.documentType))
            .every((item) => !item.isMandatory || item.documentRemarks !== null);
          Digit?.SessionStorage.set("isDocValidated", isDocValidated); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          // Modal(`Payment head updated`, `Payment heads for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
        onError: (err) => {
          console.log("Error1", err);
          Modal("Update Error", "Something went wrong!!", "error");
        },
      }
    );
  };
  const handleNoWorkflowNoc = (nocDetails, setLoading) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      nocDetails: nocDetails,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.BPA?.[0]);
          setLoading(false);
          // const isDocValidated = result?.BPA?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          Digit?.SessionStorage.set("isNocValidated", true); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          Modal(`NOC details updated`, `NOC details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
        onError: (err) => {
          console.log("ERRRO2", err);
          Modal("Update Error", "Something went wrong!!", "error");
        },
      }
    );
  };
  const handleNoWorkflowPFAR = (pfarDetails) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      ...pfarDetails,
      workflow,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.BPA?.[0]);
          if (typeof refetch === "function") {
            console.log("refetchoccured");
            refetch();
          }
          Modal(`PFAR details updated`, `PFAR details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
        onError: (err) => {
          console.log("Error3", err);
          Modal("Update Error", "Something went wrong!!", "error");
        },
      }
    );
  };

  const handleCompletionChecklistSave = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      console.log("formDataOnTabChange", formData, nextTabNo);
      try {
        data.workflow = {
          action: "NOWORKFLOW",
          comments: "",
        };
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: () => {
              onSelect("", data);
              // setShowToast({ error: false, message: `Data has been saved successfully` });
              Modal("Remarks Added", `Remarks Added Successfully !`, "success");
            },
            onError: (err) => {
              console.log("Error4", err);
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
  };

  function htmlToText(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  const handleAdditionalComment = () => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      additionalComment: htmlToText(additionalComment),
      mapSubDetails: {
        ...formData?.mapSubDetails,
        formattedAdditionalComment: additionalComment,
      },
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate1212123", result);
          Modal("Additional Comment Added", "Additional Comment Added Successfully !", "success");
          onSelect("", result?.BPA?.[0]);
        },
        onError: (err) => {
          console.log("Error21", err);
          Modal("Update Error", "Something went wrong!!", "error");
        },
      }
    );
  };

  // const initialUrl =  fetchInitialUrl(documentSection?.[0]?.fileStoreId).then((url) => {
  //   console.log("initialUrl", url);
  // });
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });

  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_MAPSUB", formData);

  const stripHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
  };
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result)); // or result.toString()
    return String(result); // Convert the result to a string before returning
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const isJE = userRolesArray?.[0]?.code === "JE";
  console.log(reduxFormData, inspectionReportChecklist?.inspectionReportData, "logging111111111111", developerRemarks);
  let userRole = userRolesArray?.[0]?.code;

  let schemeType = formData?.descriptionOfLand?.schemeType;
  let landArea = formData?.descriptionOfLand?.landArea;
  let primaryUse = formData?.primaryUse;

  let isResidential = primaryUse === "Residential";
  let isCommercial = primaryUse === "Commercial";
  let isScheme = schemeType === "Scheme";
  let isUnapproved = schemeType !== "Scheme";
  const isLowRiskCase = formData?.riskType === "LOW";
  console.log({ isResidential, isCommercial, isScheme, isUnapproved, userRoles, landArea }, workflowDetails, "loggingConditions");

  // let actions = workflowDetails?.data?.actionState?.actionState?.nextActions?.filter((item) => {
  //   if (isNocModule) {
  //     return item.action === "DEEMED_APPROVAL" ? false : true;
  //   }
  //   if (!isPurchasbleReq) {
  //     return item.action !== "HOLD_AT_JE";
  //   }
  //   if (isDa) {
  //     if (isScheme) {
  //       // Approved layout workflow
  //       if ((userRole === "EE" || userRole === "TP") && isResidential && landArea > 500) {
  //         return item.action === "SEND_TO_NEXT_LEVEL";
  //       }
  //       if ((userRole === "EE" || userRole === "TP") && isResidential && landArea <= 500) {
  //         return item.action !== "SEND_TO_NEXT_LEVEL";
  //       }

  //       if (userRole === "CTP") {
  //         if (isResidential) {
  //           if (landArea >= 500 && landArea <= 2000) return item.action !== "SEND_TO_NEXT_LEVEL";
  //           if (landArea > 2000) return item.action === "SEND_TO_NEXT_LEVEL";
  //         }

  //         if (isCommercial && landArea <= 500) return true;

  //         // Catch-all for CTP with unhandled conditions
  //         return item.action === "SEND_TO_NEXT_LEVEL";
  //       }

  //       return true;
  //     } else {
  //       // Unapproved layout workflow
  //       if (
  //         (userRole === "EE" || userRole === "TP" || userRole === "CTP" || userRole === "Additional_Secretory") &&
  //         !(item.action === "SEND_BACK" || item.action === "SEND_TO_NEXT_LEVEL")
  //       ) {
  //         return false;
  //       }
  //       return true;
  //     }
  //   } else {
  //     const isResidentialCase = isResidential;
  //     const isNonResidentialCase = !isResidential;

  //     const isAPSmallResidential = userRole === "AP" && isResidentialCase && landArea <= 500;
  //     const isCAPMidResidential = userRole === "CAP" && isResidentialCase && landArea >= 500 && landArea <= 2000;
  //     const isHCCase = userRole === "HC" && ((isResidentialCase && landArea <= 2000) || (isNonResidentialCase && landArea > 500));

  //     if (item.action === "PROVISIONALLY_APPROVAL") {
  //       return isAPSmallResidential || isCAPMidResidential || isHCCase;
  //     }

  //     return true;
  //   }
  // });

  let actions = workflowDetails?.data?.nextActions?.filter((e) => {
    const previousAction = workflowDetails?.data?.actionState?.timeline?.[0]?.performedAction;
    console.log("previousAction1", previousAction, workflowDetails);

    if (!isPurchasbleReq) {
      return e.action !== "HOLD_AT_JE";
    }
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });

  console.log("filteredActions2", actions, formData);
  // Ensure actions is always an array
  if (!Array.isArray(actions)) {
    actions = [];
  }
  // Inject 'Reject' action for specific planOn value
  if (isSelfApproval && formData?.status === "APPROVED") {
    const hasReject = actions.some((a) => a.action === "Reject");
    if (!hasReject) {
      actions = [...actions, { action: "Reject", roles: "" }];
    }
  }
  console.log("actionsfromuseempmapsubmission", actions);

  let tabList = [
    { label: "Application Data", color: "red" },
    { label: "Documents", color: "red" },
    { label: "Drawings", color: "red" },
    { label: "Site Inspection", color: "green" },
    (!isDa && !isEE) || isDa ? { label: "Payment Heads", color: "red" } : null,
    { label: "WF_TAKE_ACTION", color: "red" },
    { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "green" }, // PurchasableFAR Checklist & FAR Details
    { label: "ChatBoard", color: "green" },
    { label: "Letter", color: "green" },
  ].filter(Boolean);
  const moduleHandlers = {
    NOC: (context) => {
      const currentNOCDept = context.userDetails?.organisationCode;
      const nocPayload = context.formData?.nocList?.find((item) => item?.businessService === currentNOCDept);
      return {
        Noc: {
          ...nocPayload,
          workflow: {
            action: context.mapSubmissionAction?.action,
            comment: context.remarks,
          },
        },
      };
    },
    BPA: (context) => {
      console.log("actionsFARAyush", context);

      const storedFileStoreId = localStorage.getItem("wf_verification_doc");
      console.log("[DEBUG] uploadedFile from localStorage:", storedFileStoreId);

      const varificationDocuments = storedFileStoreId
        ? [
            {
              documentType: "verifactionDocument",
              fileStoreId: storedFileStoreId,
            },
          ]
        : null;

      return {
        BPA: {
          ...context.formData,
          customLetter: context.typeOfLetter,
          nocDetails: context.params?.nocDetails,
          workflow: {
            action: context.mapSubmissionAction?.action,
            comments: context.remarks,
            varificationDocuments: varificationDocuments,
          },
          documents: [...context.params?.documents, ...context.customLetter],
          taxHeadEstimates: [...context.params?.taxHeadEstimates] || [],
          inspectionDetailData: inspectionDataResp
            ? inspectionDataResp
            : ["JE", "EE"].includes(context.userRolesArray?.[0]?.code)
            ? formData?.inspectionDetailData
            : context.updatedInspectionReportData || formData?.inspectionDetailData,
        },
      };
    },
  };
  const validateBeforeSubmit = ({
    isValidEmp,
    currentAction,
    mapSubmissionAction,
    isDocValidated,
    remarks,
    dscValidation,
    setError,
    isNotingValidated,
  }) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return false;
    }

    if (!currentAction?.action && !mapSubmissionAction?.action) {
      Modal("Action required", "Please select at least one action.", "error");
      return false;
    }

    if (!isNotingValidated) {
      Modal("Noting Remark", "Please add Noting Remark and click on Save", "error");
      return false;
    }

    if (!isPlinthSubmission && !isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return false;
    }

    if (dscValidation) {
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return false;
    }
    const plainText = stripHtmlTags(remarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return false;
    }

    setError(false);
    return true;
  };
  const onSuccessHandlers = {
    NOC: (formData, currentAction, t, clearParams) => {
      Modal(
        `Application ${t(currentAction?.action)}`,
        `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)}</strong> updated successfully.`,
        "success",
        "/digit-ui/employee"
      );
      clearParams();
      Digit?.SessionStorage.del("EMP_MAPSUB");
      Digit?.SessionStorage.del("isDocValidated");
      Digit?.SessionStorage.del("isNotingValidated");
      Digit?.SessionStorage.del("isPaymenthead");
      // Add any NOC-specific session cleanup here
    },

    BPA: (formData, currentAction, t, clearParams) => {
      Modal(
        `Application ${t(currentAction?.action)}`,
        `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)}</strong> updated successfully.`,
        "success",
        "/digit-ui/employee"
      );
      clearParams();
      Digit?.SessionStorage.del("EMP_MAPSUB");
      Digit?.SessionStorage.del("isDocValidated");
      Digit?.SessionStorage.del("isNotingValidated");
      Digit?.SessionStorage.del("customLetter");
      localStorage.removeItem("wf_verification_doc");
      // Add any BPA-specific session cleanup here
    },
  };

  const handleSubmit = () => {
    console.log("[DEBUG] handleSubmit called, uploadedFile state:", uploadedFile, "localStorage:", localStorage.getItem("wf_verification_doc"));

    if (currentAction?.action === "SHORTFALL") {
      if (Object.prototype.hasOwnProperty.call(formData, "IsSignedDrawingPdfURL") && formData.IsSignedDrawingPdfURL === true) {
        formData.IsSignedDrawingPdfURL = false;
      }

      if (Object.prototype.hasOwnProperty.call(formData, "signedDrawingPdfURL") && formData.signedDrawingPdfURL !== "") {
        formData.signedDrawingPdfURL = "";
      }
    }

    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction,
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
      updatedInspectionReportData,
    };

    console.log("CurrentActionAS", currentAction, formData);

    const dscValidation =
      formData?.status?.startsWith("APPLY_FOR_DSC") &&
      (!formData?.IsApprovalCertificate || (!isCompletionPortal && !formData?.IsSignedDrawingPdfDscEmp));
    const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");
    const isNotingValidated = Digit?.SessionStorage?.get("isNotingValidated");
    const skipValidation = isSelfApproval;
    let isValid = true;
    if (!skipValidation) {
      isValid = validateBeforeSubmit({
        isValidEmp,
        currentAction,
        mapSubmissionAction,
        isDocValidated,
        remarks,
        dscValidation,
        setError,
        isNotingValidated,
      });
    }
    if (!isValid) return;

    setLoader(true);

    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    // if (isSelfApproval) {
    // payload.BPA.status = "REJECTED";
    // payload.BPA.workflow = {
    //   action: "NOWORKFLOW_SELF",
    //   comments: context.remarks,
    // };
    // }
    console.log("payloadFromSubmit", payload, "context", context);

    updateApiCall.mutate(payload, {
      onSuccess: (result) => {
        onSuccessHandlers[moduleKey](formData, currentAction, t, clearParams);
      },
      onError: (err) => {
        console.log("ERRROR", err);
        Modal("Update Error", "Something went wrong!!", "error");
      },
    });

    setLoader(false);
  };

  // const handleSubmit = () => {
  //   if (isNocModule) {
  //     const currentNOCDept = userDetails?.organisationCode;
  //     const nocPayload = formData?.nocList?.find((item) => item?.additionalDetails?.workflowCode === currentNOCDept);
  //     const workflow = {
  //       action: mapSubmissionAction?.action,
  //       comments: remarks,
  //     };
  //     const appData = {
  //       ...nocPayload,
  //       workflow,
  //       // approvalLetterId: structureCertificateId,
  //       // approvalLetterUrl: structureCertificateUrl,
  //     };
  //     console.log("nocPayloadUpdate", nocPayload, appData);

  //     updateApiCall.mutate(
  //       { Noc: appData },
  //       {
  //         onSuccess: (result) => {
  //           console.log("resultFromUpdate", result);
  //           // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
  //           Modal(
  //             `Application ${t(currentAction?.action)}`,
  //             `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)} </strong> Updated Successfully!`,
  //             "success",
  //             "/digit-ui/employee"
  //           );
  //           clearParams();
  //           Digit?.SessionStorage.del("EMP_MAPSUB");
  //           Digit?.SessionStorage.del("isDocValidated");
  //           Digit?.SessionStorage.del("isPaymenthead");
  //         },
  //       }
  //     );
  //     return;
  //   }
  //   // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
  //   console.log("loggingRemarks", remarks, currentAction);
  //   // handleGetNotingById(formData?.applicationNo);
  //   // const isShortfall =
  //   //   notingRemarksData?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.documentDetails?.dataRecommendation === "Shortfall" ||
  //   //   notingRemarksData?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.drawingsDetails?.dataRecommendation === "Shortfall" ||
  //   //   notingRemarksData?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.inspectionDetails?.dataRecommendation === "Shortfall";
  //   const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");
  //   const isNocValidated = Digit?.SessionStorage?.get("isNocValidated");
  //   if (!isValidEmp) {
  //     Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
  //     return;
  //   }
  //   // if (!isLowRiskCase && !isNocValidated && isJE) {
  //   //   Modal("NOC required", "Please select at least one NOC.", "error");
  //   //   return;
  //   // }

  //   if (currentAction?.action == null && mapSubmissionAction?.action == null) {
  //     Modal("Action required", "Please select at least one action.", "error");
  //     return;
  //   }
  //   //  const isDocValidated = updatedDocuments?.some((item) => item.documentRemarks !== null);
  //   // const isDocValidated1 = updatedDocuments?.some((item) => item.documentRemarks !== null);
  //   console.log({ isDocValidated, updatedDocuments }, "uspspsp");

  //   // const isPaymenthead =  taxHead?.some((item) => item.calculationBusinesserviceId == "BPA.MAP_SUBMISSION_FORM_FEE2");
  //   // const isPaymenthead = Digit?.SessionStorage?.get("isPaymenthead");
  //   // console.log("isPaymenthead", isPaymenthead);
  //   // const isSiteInspectionReport = Object.values(siteInspectionRemarksData?.DetailDataRemarks)?.some((item) => item?.inspectionDetails != null);
  //   if (!isDocValidated) {
  //     Modal("Review documents section", "Please review the documents section and click on Save", "error");
  //     return;
  //   }
  //   // if (userRolesArray?.[0]?.code === "JE" && !isSiteInspectionReport) {
  //   //   Modal("Site Inspection Report", "Please fill the site inspection report", "error");
  //   //   return;
  //   // }
  //   // if (
  //   //   (isDa && userRolesArray?.[0]?.code === "JE" && !isPaymenthead) ||
  //   //   (!isDa && userRolesArray?.[0]?.code === "AA" && !isPaymenthead)
  //   // ) {
  //   //   Modal("Select payment head", "Please select payment heads in payment head section", "error");
  //   //   return;
  //   // }
  //   //below section will be enabled once recommendation section is configured in NOC status tab.
  //   // if (mapSubNocDetails?.mapSubOfficerNoc?.length < 1 && mapSubNocDetails?.mapSubAdditionalOfficerNoc?.length < 1) {
  //   //   Modal("NOC Shortfall Marked", "Please select NOC from select Noc tab as you have marked shortfall in NOC status section", "error");
  //   //   return;
  //   // }
  //   const plainText = stripHtmlTags(remarks);
  //   console.log("handleRenarksCalled", plainText, plainText.trim().length);
  //   if (plainText.trim().length === 0) {
  //     setError(true);
  //     return;
  //   } else {
  //     setError(false);
  //   }
  //   setLoader(true);
  //   const workflow = {
  //     action: mapSubmissionAction?.action,
  //     comments: remarks,
  //   };
  //   const appData = {
  //     ...formData,
  //     customLetter: typeOfLetter,
  //     nocDetails: params?.nocDetails,
  //     workflow,
  //     documents: [...params?.documents, ...customLetter],
  //     taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHead] || [],
  //     inspectionDetailData:
  //       userRolesArray?.[0]?.code === "JE" || userRolesArray?.[0]?.code === "EE"
  //         ? siteInspectionRemarksData?.DetailDataRemarks?.[0]?.inspectionDetails
  //         : formData?.inspectionDetailData,
  //     // approvalLetterId: structureCertificateId,
  //     // approvalLetterUrl: structureCertificateUrl,
  //   };
  //   console.log("LetterOfAttachment", appData);
  //   console.log("loggingAction", currentAction, appData);
  //   updateApiCall.mutate(
  //     { BPA: appData },
  //     {
  //       onSuccess: (result) => {
  //         console.log("resultFromUpdate", result);
  //         // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
  //         Modal(
  //           `Application ${t(currentAction?.action)}`,
  //           `Application <strong>(${formData?.applicationNo}) ${t(currentAction?.action)} </strong> Updated Successfully!`,
  //           "success",
  //           "/digit-ui/employee"
  //         );
  //         clearParams();
  //         Digit?.SessionStorage.del("EMP_MAPSUB");
  //         Digit?.SessionStorage.del("isDocValidated");
  //         Digit?.SessionStorage.del("isPaymenthead");
  //       },
  //     }
  //   );
  //   Digit?.SessionStorage.del("EMP_MAPSUB");
  //   setLoader(false);
  // };

  console.log("paymentHeadForHeadValidation1", chatBoardDataRemarks, chatBoardHistoryData, notingRemarksData);

  console.log("paymentHeadForHeadValidation", taxHead, paymentHeadRemarksData, documentRemarksData, siteInspectionRemarksData);

  // inspectionReportData API Call

  // const callInspectionDetailsAPI = async (data) => {
  //   debugger;
  //   console.log("Received from child:", data);
  //   setLoader(true);
  //   const postData = {
  //     RequestInfo: {
  //       apiId: "Rainmaker",
  //       authToken: authToken,
  //       userInfo: userInfo,
  //       msgId: "1743578637716|en_IN",
  //     },
  //     DetailDataRemarks: {
  //       userDetails: {
  //         userID: userInfo?.id || null,
  //         name: userInfo?.name || null,
  //         employeeName: userInfo?.name || null,
  //         role: userRolesArray?.[0]?.code,
  //         applicationID: formData?.applicationNo,
  //         designation: userRolesArray?.[0]?.name,
  //         applicationStatus: formData?.status,
  //       },
  //       isApproved: "InspectionDetail",
  //       inspectionDetails: {
  //         ...data,
  //       },
  //     },
  //   };

  //   try {
  //     const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
  //       console.log("log1223", Resp, response.data);
  //       return response.data;
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   setLoader(false);
  //   Modal("Application Inspection Details ", `Application <strong>(${formData?.applicationNo}) Inspection Details </strong>Successfully!`, "success");
  //   await handleGetSiteInspectionById(formData?.applicationNo);
  //   handleChange(undefined, "4");
  // };

  // inspectionReportData API Call
  const callInspectionDetailsAPI = async (data) => {
    console.log("Received from child:", data);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "InspectionDetail",
        inspectionDetails: {
          ...data,
        },
      },
    };

    try {
      if (
        isDa &&
        formData?.riskType === "LOW" &&
        inspectionReportChecklist?.inspectionReportData?.siteInspecionConstructionONSite != null &&
        userRolesArray?.[0]?.code === "JE"
      ) {
        console.log("Logging: LOW risk + Construction filled + Role is JE");
        const resp = await axios.post(Urls.bpaService.remarksDetail, postData).then((response) => {
          console.log("log12234", response.data);
          return response.data;
        });
        setInspectionDataResp(resp?.DetailDataRemarks?.[0]?.inspectionDetails);
        onSelect("", {
          ...formData,
          inspectionDetailData: resp?.DetailDataRemarks?.[0]?.inspectionDetails,
        });
      } else if (formData?.riskType !== "LOW") {
        console.log("Logging: Not LOW risk");
        const resp = await axios.post(Urls.bpaService.remarksDetail, postData).then((response) => {
          console.log("log12235", response.data);
          return response.data;
        });
        setInspectionDataResp(resp?.DetailDataRemarks?.[0]?.inspectionDetails);
        onSelect("", {
          ...formData,
          inspectionDetailData: resp?.DetailDataRemarks?.[0]?.inspectionDetails,
        });
      } else if (formData?.riskType === "LOW" && inspectionReportChecklist?.inspectionReportData?.siteInspecionConstructionONSite === null) {
        console.log("Logging: LOW risk + Construction missing");
        Modal("Missing Construction Details", "Please fill the <strong>Site Inspection Construction ONSite</strong> before submitting.", "error");
        return;
      }
      // else {
      //   // 👇 Fallback for any unmet combination
      //   console.log("Logging: Conditions not satisfied");
      //   Modal("Submission Blocked", "Inspection submission not allowed. Please check <strong>Construction On Site data</strong>.", "error");
      //   return;
      // }

      // ✅ Success flow
      Modal(
        "Application Inspection Details",
        `Application <strong>(${formData?.applicationNo}) Inspection Details</strong>Updated Successfully!`,
        "success"
      );
      await handleGetSiteInspectionById(formData?.applicationNo);
      handleChange(undefined, 5);
    } catch (error) {
      console.log("API Error:", error);
      Modal("API Error", "Something went wrong while submitting the inspection details.", "error");
    } finally {
      setLoader(false);
    }
  };
  // DocumentDetails API Call
  // const callDocumentDetailsAPI = async (developerRemarks,dataRecommendation) => {
  //   console.log("selectedObjection1", selectedObjection, dataRecommendationDocument);

  //   setLoader(true);
  //   const postData = {
  //     RequestInfo: {
  //       apiId: "Rainmaker",
  //       authToken: authToken,
  //       userInfo: userInfo,
  //       msgId: "1743578637716|en_IN",
  //     },
  //     DetailDataRemarks: {
  //       userDetails: {
  //         userID: userInfo?.id || null,
  //         name: userInfo?.name || null,
  //         employeeName: userInfo?.name || null,
  //         role: userRolesArray?.[0]?.code,
  //         applicationID: formData?.applicationNo,
  //         designation: userRolesArray?.[0]?.name,
  //         applicationStatus: formData?.status,
  //       },
  //       isApproved: "DocumentDetails",
  //       documentDetails: {
  //         dataRecommendation: dataRecommendation,
  //         developerRemarks: developerRemarks,
  //         documents: updatedDocuments,
  //       },
  //     },
  //   };

  //   try {
  //     const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
  //       console.log("log1223", Resp, response.data);
  //       return response.data;
  //     });
  //     setLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   Modal(`Documents updated`, `Documents details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
  //   // Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
  //   await handleGetDocumentById(formData?.applicationNo);
  //   handleChange(undefined, "2");
  // };
  const callDocumentDetailsAPI = async (developerRemarks, dataRecommendation, documents) => {
    const finalRecommendation = dataRecommendation !== undefined && dataRecommendation !== null ? dataRecommendation : dataRecommendationDocument;

    const finalRemarks = developerRemarks !== undefined && developerRemarks !== null ? developerRemarks : developerRemarksDocument;

    const finalDocuments = documents !== undefined && documents !== null ? documents : updatedDocuments;

    if (!finalRecommendation || !finalRemarks || !finalDocuments || finalDocuments.length === 0) {
      console.log("Data not ready, API blocked");
      return;
    }

    setLoader(true);

    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },

      DetailDataRemarks: {
        userDetails: {
          userID: userInfo && userInfo.id ? userInfo.id : null,
          name: userInfo && userInfo.name ? userInfo.name : null,
          employeeName: userInfo && userInfo.name ? userInfo.name : null,
          role: userRolesArray && userRolesArray[0] ? userRolesArray[0].code : null,
          applicationID: formData ? formData.applicationNo : null,
          designation: userRolesArray && userRolesArray[0] ? userRolesArray[0].name : null,
          applicationStatus: formData ? formData.status : null,
        },

        isApproved: "DocumentDetails",

        documentDetails: {
          dataRecommendation: finalRecommendation,
          developerRemarks: finalRemarks,
          documents: finalDocuments,
        },
      },
    };

    try {
      const response = await axios.post(Urls.bpaService.remarksDetail, postData);

      console.log("response", response.data);

      Modal("Documents updated", `Document details for <strong>(${formData.applicationId})</strong> updated successfully!`, "success");

      // await handleGetDocumentById(
      //   formData.applicationNumber
      // );
      await handleGetDocumentById(formData?.applicationNo);
      handleChange(undefined, "2");
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (callAPI && updatedDocuments?.length > 0 && dataRecommendationDocument && developerRemarksDocument) {
      callDocumentDetailsAPI(developerRemarksDocument, dataRecommendationDocument);

      setCallAPI(false); // reset after one hit
    }
  }, [callAPI, updatedDocuments, dataRecommendationDocument, developerRemarksDocument]);

  useEffect(() => {
    console.log("applicationRemarksFetch", formData?.applicationNo);
    if (formData?.applicationNo) {
      handleGetDocumentById(formData.applicationNo);
    }
  }, [formData?.applicationNo]);

  useEffect(() => {
    console.log(documentRemarksData, documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.dataRecommendation, "documentRemarksData");

    if (documentRemarksData?.DetailDataRemarks) {
      setDataRecommendationDocument(documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.dataRecommendation || "");
      setDeveloperRemarksDocument(documentRemarksData?.DetailDataRemarks?.[0]?.documentDetails?.developerRemarks || "");
    }
  }, [documentRemarksData?.DetailDataRemarks]);
  // PaymentDetails API Call
  const callPaymentDetailsAPI = async (value) => {
    console.log("Received from child:", value);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "PaymentDetails",
        paymentDetails: {
          dataRecommendation: paymentRecommendation,
          developerRemarks: paymentRemarks,
          paymentHead: taxHead,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Payment Head remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetPaymentHeadById(formData?.applicationNo);
    handleChange(undefined, "5");
  };

  const callDrawingDetailsAPI = async (value, value2) => {
    console.log("Received from child:", value, value2);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "DrawingsDetails",
        drawingsDetails: {
          dataRecommendation: drawingRecommendation,
          developerRemarks: drawingRemarks,
          developerObjection: value2,
          drawingsDetails: formData?.drawingDetail,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Drawings Details remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetDrawingById(formData?.applicationNo);
    handleChange(undefined, "5");
  };
  //PFAR Remarks API Call
  const callPfarDetailsAPI = async (value) => {
    console.log("Received from child:", value);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "remarksDetails",
        remarksDetails: {
          developerRemarks: developerRemarks || value,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("PFAR remarks details saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handlepFarDetailById(formData?.applicationNo);
    handleChange(undefined, "5");
  };
  // NotingDetails API Call
  const callNotingDetailsAPI = async () => {
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "notingDetails",
        notingDetails: {
          developerRemarks: developerRemarks,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223Noting", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Noting remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetNotingById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  // NocDetails API Call
  const callNocDetailsAPI = async () => {
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "nocDetails",
        nocDetails: {
          developerRemarks: developerNocRemarks,
          dataRecommendation: dataNocRecommendation,
          nocDetails: formData?.nocDetails,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223Noting", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Noc remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetNocById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  const onDropDownSelect = (event) => {
    const value = event.target.value;
    if (isMapSubmission || isPlinthSubmission || isPurchasbleFAR || isCompletionPortal || isCompounding) {
      console.log("radioAction", value);
      setMapSubmissionAction(value);
      setCurrentAction(value);
    } else {
      setCurrentAction(value);
    }
    if (isPlinthSubmission) {
      setCurrentAction(value);
    }
    if (isCompounding) {
      setCurrentAction(value);
    }
    function onSelect(val) {
      if (val !== selectedOption || props.allowMultiselect) {
        props.select(val);
        setSelectedOption(val);
        setDropdownStatus(false);
      } else {
        setSelectedOption(val);
        setforceSet(forceSet + 1);
      }
    }
  };
  // console.log(dataRecommendationDocument, developerRemarksDocument, updatedDocuments, "loggingDataRecommendation");

  // useEffect(() =>{
  //   if (dataRecommendation && developerRemarks && isValidEmp) {
  //       callPaymentDetailsAPI();
  // }
  //   }, [dataRecommendation, developerRemarks, isValidEmp]); // 🔒 empty dependency = runs only once after first rende  r

  useEffect(() => {
    const applicationNumber = formData?.applicationNo;

    if (!applicationNumber) {
      console.warn("⚠️ Application number not found yet.");
      return;
    } // Call all 3 API functions
    onSelect("", formData);
    handleGetPaymentHeadById(applicationNumber);
    handleGetDocumentById(applicationNumber);
    handleGetSiteInspectionById(applicationNumber);
    handleGetDrawingById(applicationNumber);
    handleGetFiledsStatesById(applicationNumber);
    handleGetRemarkssValues(applicationNumber);
    handleGetNotingById(applicationNumber);
    handleGetNocById(applicationNumber);
    handlepFarDetailById(applicationNumber);
    // handleGetHistoryRemarkssValues(applicationNumber);
  }, [formData?.applicationNo]); // 🔒 empty dependency = runs only once after first render

  console.log("dataRecommendation000", dataRecommendation, developerRemarks, updatedDocuments);

  const handleChange = (event, nextTab) => {
    debugger;
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = (value) => {
    setCurrentAction(value);
  };
  const filters = {
    // appType:formType,
    applicationNo: id,
  };
  console.log("loggingActionsFromHook", actions);

  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    // documentSectionForCompounding,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    drawingRemarks,
    paymentRemarks,
    setDeveloperRemarks,
    setPaymentRemarks,
    setDrawingRemarks,
    setPaymentRecommendation,
    setDrawingRecommendation,
    paymentRecommendation,
    drawingRecommendation,
    drawingPdfs,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    setDeveloperNocRemarks,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    nocRemarksData,
    dataRecommendationDocument,
    setSelectedObjection,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callPfarDetailsAPI,
    callNotingDetailsAPI,
    callNocDetailsAPI,
    paymentHeadRemarksData,
    documentRemarksData,
    updatedInspectionReportData,
    siteDrawingRemarksData,
    pFarDetailsData,
    chatBoardDataRemarks,
    chatBoardHistoryData,
    notingRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    handleNoWorkflowPFAR,
    mapSubmissionAction,
    userRolesArray,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isPurchasbleReq,
    currentFormData,
    handleGetSiteInspectionById,
    isFromDashboard,
    daLogo,
    avpLogo,
    siteInspectionRemarksData,
    callDocumentDetailsAPI,
    uploadedFile,
    setUploadedFile,
    // developerUpdateDocument,
    handleCompletionChecklistSave,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
  };
};
export default useEmpMapSubmission;
